export default {
  resourcesWithTag: 'Ressources avec cette étiquette',
  resourcesDescription: 'Parcourir toutes les ressources associées à cette étiquette'
};
